import MLMenu from "./MLMenu.js";
import { isMobile } from "./utils/deviceCheck.js";

export function initMenu() {
    if (!isMobile()) return;

    const menuEl = document.getElementById("ml-menu");
    const mlmenu = new MLMenu(menuEl, {
        backCtrl: true, // no back button
        onItemClick: onMenuItemClick,
    });

    // toggle controls
    const openMenuCtrl = document.querySelector(".action--open");
    const closeMenuCtrl = document.querySelector(".action--close");

    openMenuCtrl.addEventListener("click", openMenu);
    closeMenuCtrl.addEventListener("click", closeMenu);

    function openMenu() {
        menuEl.classList.add("menu--open");
        closeMenuCtrl.focus();
    }

    function closeMenu() {
        menuEl.classList.remove("menu--open");
        openMenuCtrl.focus();

        // 🔑 Reset to main menu level
        resetToMain();
    }

    function onMenuItemClick(ev, itemName) {
        // ev.preventDefault();

        closeMenu();
        console.log("Clicked item:", itemName);
    }

    function resetToMain() {
        const mainMenu = mlmenu.menusArr[0].menuEl;
        const currentMenu = mlmenu.menusArr[mlmenu.current_menu].menuEl;

        if (mlmenu.current_menu !== 0) {
            // remove active classes from current submenu
            currentMenu.classList.remove("menu__level--current");
            currentMenu.classList.remove(
                "animate-inFromRight",
                "animate-inFromLeft",
                "animate-outToLeft",
                "animate-outToRight"
            );

            // set main menu as active
            mainMenu.classList.add("menu__level--current");

            // reset state
            mlmenu.current_menu = 0;
        }
    }
}
